import { useAuth } from "@workos-inc/authkit-react";

export function useFeatureFlags(): string[] {
  const { featureFlags } = useAuth();
  return featureFlags ?? [];
}
